/**
 * Constants instead of typescript enums ---> smaller bundle size
 */
export const PointersOverlap = 'pointers-overlap';
export const PointersMinDistance = 'pointers-min-distance';
export const PointersMaxDistance = 'pointers-max-distance';
export const RangeDragging = 'range-dragging';

export const Data = 'data';
export const Min = 'min';
export const Max = 'max';
export const Step = 'step';
export const Round = 'round';
export const Type = 'type';
export const Theme = 'theme';
export const RightToLeft = 'rtl';
export const BottomToTop = 'btt';

export const Disabled = 'disabled';
export const KeyboardDisabled = 'keyboard-disabled';
export const MousewheelDisabled = 'mousewheel-disabled';

export const SliderWidth = 'slider-width';
export const SliderHeight = 'slider-height';
export const SliderRadius = 'slider-radius';

export const SliderBg = 'slider-bg';
export const SliderBgHover = 'slider-bg-hover';
export const SliderBgFill = 'slider-bg-fill';

export const PointerWidth = 'pointer-width';
export const PointerHeight = 'pointer-height';
export const PointerRadius = 'pointer-radius';
export const PointerBg = 'pointer-bg';
export const PointerBgHover = 'pointer-bg-hover';
export const PointerBgFocus = 'pointer-bg-focus';
export const PointerShadow = 'pointer-shadow';
export const PointerShadowHover = 'pointer-shadow-hover';
export const PointerShadowFocus = 'pointer-shadow-focus';
export const PointerBorder = 'pointer-border';
export const PointerBorderHover = 'pointer-border-hover';
export const PointerBorderFocus = 'pointer-border-focus';

export const AnimateOnClick = 'animate-onclick';
export const CSSLinks = 'css-links';
